<template>
  <div id="dashboard-por-indicador">
    <div class="row align-items-center">
      <div class="col-lg-4">
        <donut-chart :series="dadosDashboard" nivel="2"></donut-chart>
      </div>
      <div class="col-lg-8">
        <tree-map
          nivel="2"
          :series="dadosDashboard"
          @openModal="openModal($event)"
        ></tree-map>
      </div>
      <b-modal v-model="modal.enabled" centered size="xl" hide-footer>
        <template #modal-title>
          {{ modal.title }}
        </template>
        <v-app class="app-tabela">
          <div class="box mt-0 mb-5">
            <v-card class="tabela">
              <v-card-title>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Buscar por nome da equipe, CNES ou INE"
                  class="input-bottom"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-data-table
                @pagination="getPagination"
                :page="currentPage"
                :footer-props="{
                  itemsPerPageText: '',
                  'items-per-page-options': [10],
                  'disable-items-per-page': true,
                }"
                :loading="modal.table.loading"
                loading-text="Carregando, Por favor espere"
                :headers="headersComputed"
                :items="indexedItems"
                :item-class="getRowColor"
                :search="search"
                :single-expand="true"
                :expanded.sync="expanded"
                item-key="index"
                :show-expand="podeExpandir"
                class="elevation-1"
                @item-expanded="onItemExpanded"
              >
                <template v-slot:[`footer.page-text`]="items">
                  <div class="info-table-item tabela-esus-pec">
                    <FonteSincronizadorC />
                  </div>
                  <span class="paginacao"
                    >{{ items.pageStart }} - {{ items.pageStop }} de
                    {{ items.itemsLength }} equipes</span
                  >
                </template>

                <template v-slot:item.nota="{ item }">
                  {{
                    selectedIndicador.indicador != 56 &&
                    selectedIndicador.indicador != 57 &&
                    selectedIndicador.indicador != 58 &&
                    selectedIndicador.indicador != 59
                      ? '-'
                      : item.nota
                  }}
                </template>

                <template v-slot:item.classificacao="{ item }">
                  <div
                    v-if="
                      selectedIndicador.indicador != 56 &&
                      selectedIndicador.indicador != 57 &&
                      selectedIndicador.indicador != 58 &&
                      selectedIndicador.indicador != 59
                    "
                  >
                    -
                  </div>
                  <div v-else>
                    {{
                      selectedIndicador.indicador == 54 ||
                      selectedIndicador.indicador == 55 ||
                      selectedIndicador.indicador == 56
                        ? item.classificacao_param
                        : item.classificacao
                    }}
                    <span
                      v-b-tooltip.html.hover
                      :title="getTextoClassificacaoTooltip(item)"
                      class="icon-tooltip"
                    >
                      <i class="icofont-info-circle"></i>
                    </span>
                  </div>
                </template>

                <template v-slot:expanded-item="{ headers, item }">
                  <td colspan="7">
                    <table class="table table-interna">
                      <thead>
                        <tr>
                          <th
                            v-for="(col, index) in expandedColumns"
                            :key="index"
                          >
                            {{ col }}
                            <span
                              v-if="
                                selectedIndicador.indicador != 54 &&
                                selectedIndicador.indicador != 55 &&
                                selectedIndicador.indicador != 56 &&
                                col != 'Indicador' &&
                                col != 'Peso' &&
                                col != 'Nota' &&
                                col != 'Classificação' &&
                                col != 'Pontuação'
                              "
                              v-b-tooltip.html.hover
                              v-bind:title="
                                getTooltipsTexts(
                                  selectedIndicador.indicador,
                                  col
                                )
                              "
                              class="icon-tooltip"
                            >
                              <i class="icofont-info-circle"></i>
                            </span>
                            <span
                              v-if="
                                selectedIndicador.indicador == 54 ||
                                selectedIndicador.indicador == 55 ||
                                selectedIndicador.indicador == 56
                              "
                              v-b-tooltip.hover.right
                              :title="expandedColumnTooltips[col]"
                              class="icon-tooltip"
                            >
                              <i class="icofont-info-circle"></i>
                            </span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td
                            v-for="(col, index) in expandedColumns"
                            :key="index"
                          >
                            <span v-if="col == 'Classificação'">
                              <TextoClassificacaoIndicador
                                :classificacao="item.classificacao"
                                :idIndicador="selectedIndicador.indicador"
                                :resultado="item.resultado"
                              />
                            </span>
                            <span v-else>
                              {{ getExpandedValue(item, col) }}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </template>

                <template v-slot:progress>
                  <v-progress-linear
                    color="blue"
                    :height="10"
                    indeterminate
                  ></v-progress-linear>
                </template>
                <template v-slot:no-data>
                  <div class="alert alert-info mb-0">
                    <b
                      >Nenhuma informação encontrada. Selecione outro filtro.</b
                    >
                  </div>
                </template>
                <template v-slot:no-results style="padding: 0px">
                  <div class="alert alert-info mb-0">
                    <b
                      >Nenhuma informação encontrada. Selecione outro filtro.</b
                    >
                  </div>
                </template>
              </v-data-table>
            </v-card>
          </div>
        </v-app>
      </b-modal>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import DonutChart from './DonutChart.vue'
import TreeMap from './TreeMap.vue'
import TextoClassificacaoIndicador from '@/components/utils/TextoClassificacaoIndicador'

export default {
  components: {
    apexchart: VueApexCharts,
    DonutChart,
    TreeMap,
    TextoClassificacaoIndicador,
  },
  props: {
    dadosDashboard: {
      type: Array,
      default: () => [],
    },
    periodo: {
      type: Object,
      default: () => {},
    },
    selectedIndicador: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      search: '',
      currentPage: 1,
      expanded: [],
      modal: {
        title: '',
        enabled: false,
        table: {
          loading: false,
          data: [],
        },
      },
      expandedColumnTooltips: {
        CIs: 'Total de Cadastro Individual (CI).',
        'CIs + CDTs':
          'Total de Cadastros Individuais (CI) + Total de Cadastros Domiciliares e Territoriais (CDT).',
        Cadastros: 'Total de cadastros no e-SUS PEC.',
        Parâmetro:
          'Quantidade mínima de cadastros estabelecida no cofinanciamento federal da APS.',
        A: 'População acompanhada sem critério × 1,0',
        B: 'População acompanhada idosa ou criança × 1,2',
        C: 'População acompanhada beneficiária do PBF ou BPC × 1,3',
        D: 'População acompanhada idosa ou criança e beneficiária do PBF ou BPC × 2,5',
        'Escore cadastros':
          'Nota do cadastro definida na portaria na nota metodológica.',
        'Escore Acompanhamento':
          'Nota do acompanhamento definida na nota metodológica do vínculo e acompanhamento.',
        Máximo:
          'Estimativa da quantidade máxima de pessoas para serem cadastradas na equipe no vínculo e acompanhamento.',
      },
    }
  },
  computed: {
    indexedItems() {
      return this.modal.table.data.map((item, index) => {
        return {
          index: index,
          ...item,
        }
      })
    },
    expandedColumns() {
      if (this.selectedIndicador.indicador == 54) {
        return ['CIs', 'CIs + CDTs', 'Cadastros', 'Parâmetro', 'Máximo']
      } else if (this.selectedIndicador.indicador == 55) {
        return ['A', 'B', 'C', 'D', 'Cadastros', 'Parâmetro', 'Máximo']
      } else if (this.selectedIndicador.indicador == 56) {
        return ['Escore cadastros', 'Escore Acompanhamento']
      } else {
        return [
          'Indicador',
          'Peso',
          'Numerador',
          'Denominador',
          'Pontuação',
          'Nota',
          'Classificação',
        ]
      }
    },
    podeExpandir() {
      return (
        this.selectedIndicador.indicador != 57 &&
        this.selectedIndicador.indicador != 58 &&
        this.selectedIndicador.indicador != 59
      )
    },
    headersComputed() {
      const base = [
        { text: 'CNES', align: 'start', filterable: true, value: 'nu_cnes' },
        { text: 'UBS', align: 'start', filterable: true, value: 'no_ubs' },
        { text: 'INE', align: 'start', filterable: true, value: 'ine' },
        {
          text: 'Equipe',
          align: 'start',
          filterable: true,
          value: 'no_equipe',
        },
        {
          text: 'Nota',
          align: 'start',
          sortable: false,
          filterable: false,
          value: 'nota',
        },
        {
          text: 'Classificação',
          align: 'start',
          sortable: false,
          filterable: false,
          value: 'classificacao',
        },
      ]
      return this.podeExpandir
        ? [...base, { text: '', value: 'data-table-expand' }]
        : base
    },
  },
  watch: {
    podeExpandir(val) {
      if (!val) this.expanded = []
    },
  },
  methods: {
    getPagination(options) {
      this.currentPage = options.page
    },

    onItemExpanded(item) {},

    getRowColor(item) {},

    getTextoClassificacaoTooltip(item) {
      const lista = this.$store.state.regrasIndicadoresAps || []
      const keyClassificacao =
        this.selectedIndicador.indicador == 54 ||
        this.selectedIndicador.indicador == 55 ||
        this.selectedIndicador.indicador == 56
          ? 'classificacao_param'
          : 'classificacao'

      // Se for Regular, pode ter vários registros
      const itens =
        item[keyClassificacao] === 'Regular'
          ? lista.filter(
              (i) =>
                i.id_indicador == this.selectedIndicador.indicador &&
                i.classificacao === item[keyClassificacao]
            )
          : [
              lista.find(
                (i) =>
                  i.id_indicador == this.selectedIndicador.indicador &&
                  i.classificacao === item[keyClassificacao]
              ),
            ].filter(Boolean)

      if (!itens.length) return null

      const partesParametro = itens
        .map((item) => {
          const partes = []

          if (item.sinal_min && item.min_val) {
            partes.push(`${item.sinal_min} ${item.min_val}`)
          }

          if (item.sinal_max && item.max_val) {
            partes.push(`${item.sinal_max} ${item.max_val}`)
          }

          // Se vierem os dois no mesmo registro, junta com " e "
          return partes.join(' e ')
        })
        .filter(Boolean)

      const parametro = partesParametro.join(' e ')

      const ref = itens[0]

      return `Peso: ${ref.peso} <br>
              Nota: ${item.nota} ${parametro} <br>
              Classificação: ${ref.classificacao} `
    },

    openModal(item) {
      this.currentPage = 1
      this.modal.enabled = true
      this.modal.title = item.x
      let dadosTabela = this.dadosDashboard.find((el) => {
        return el.classificacao == item.x
      })
      if (dadosTabela != undefined) {
        this.modal.table.data = JSON.parse(dadosTabela.equipes) ?? []
      }
    },

    getTooltipsTexts(idIndicador, col) {
      const nomesIndicadores = {
        46: {
          numerador:
            'Total de atendimentos por demanda programada (consulta agendada programada; cuidado continuado; e consulta agendada).',
          denominador:
            'Total de atendimentos por todos os tipos de demandas (espontâneas e programadas).',
          resultado: 'Numerador / Denominador * 100',
          classificacao: [
            'Regular: <= 10 ou > 70',
            'Suficiente: > 10 e <= 30',
            'Bom: > 30 e <= 50',
            'Ótimo: > 50 e <= 70',
          ],
        },
        51: {
          numerador:
            'Somatório da(s) boa(s) prática(s) pontuada(s) durante o acompanhamento do desenvolvimento infantil.',
          denominador:
            'Total de crianças com idade igual a 2 (dois) anos completos.',
          resultado: 'Numerador / Denominador',
          classificacao: [
            'Regular: <= 25',
            'Suficiente: > 25 e <= 50',
            'Bom: > 50 e <= 75',
            'Ótimo: > 75 e <= 100',
          ],
        },
        52: {
          numerador:
            'Somatório da(s) boa(s) prática(s) pontuada(s) durante o acompanhamento de uma pessoa gestante e puérpera.',
          denominador:
            'Total de mulheres com encerramento de puerpera no quadrimestre avaliado.',
          resultado: 'Numerador / Denominador',
          classificacao: [
            'Regular: <= 25',
            'Suficiente: > 25 e <= 50',
            'Bom: > 50 e <= 75',
            'Ótimo: > 75 e <= 100',
          ],
        },
        48: {
          numerador:
            'Somatório da(s) boa(s) prática(s) pontuada(s) durante o acompanhamento da pessoa com diabetes.',
          denominador: 'Total de pessoas com diabetes.',
          resultado: 'Numerador / Denominador',
          classificacao: [
            'Regular: <= 25',
            'Suficiente: > 25 e <= 50',
            'Bom: > 50 e <= 75',
            'Ótimo: > 75 e <= 100',
          ],
        },
        50: {
          numerador:
            'Somatório da(s) boa(s) prática(s) pontuada(s) durante o acompanhamento da pessoa com hipertensão arterial.',
          denominador: 'Total de pessoas com hipertensão arterial.',
          resultado: 'Numerador / Denominador',
          classificacao: [
            'Regular: <= 25',
            'Suficiente: > 25 e <= 50',
            'Bom: > 50 e <= 75',
            'Ótimo: > 75 e <= 100',
          ],
        },
        49: {
          numerador:
            'Somatório da(s) boa(s) prática(s) pontuada(s) durante o acompanhamento da pessoa idosa.',
          denominador: 'Total de pessoas idosas.',
          resultado: 'Numerador / Denominador',
          classificacao: [
            'Regular: <= 25',
            'Suficiente: > 25 e <= 50',
            'Bom: > 50 e <= 75',
            'Ótimo: > 75 e <= 100',
          ],
        },
        47: {
          numerador:
            'Somatório da(s) boa(s) prática(s) aplicável(is) para a mulher.',
          denominador: 'Total de mulheres elegíveis na faixa etária.',
          resultado: 'Numerador / Denominador',
          classificacao: [
            'Regular: <= 25',
            'Suficiente: > 25 e <= 50',
            'Bom: > 50 e <= 75',
            'Ótimo: > 75 e <= 100',
          ],
        },
        44: {
          numerador:
            'Total de atendimentos individuais e coletivos realizados pela eMulti no quadrimestre avaliado.',
          denominador: 'Total de pessoas atendidas no quadrimestre avaliado.',
          resultado: 'Numerador / Denominador',
          classificacao: [
            'Regular: <= 1',
            'Suficiente: > 1 e <= 2',
            'Bom: > 2 e <= 3',
            'Ótimo: > 3',
          ],
        },
        45: {
          numerador:
            'Total de ações compartilhadas realizadas pela eMulti no quadrimestre avaliado.',
          denominador: 'Total de ações realizadas pela eMulti.',
          resultado: 'Numerador / Denominador * 100',
          classificacao: [
            'Regular: <= 1',
            'Suficiente: > 1 e <= 2,5',
            'Bom: > 2,5 e <= 5',
            'Ótimo: > 5',
          ],
        },
        38: {
          numerador:
            'Total de pessoas com atendimentos de primeira consulta odontológica programática.',
          denominador: 'Total de pessoas vinculadas à equipe.',
          resultado: 'Numerador / Denominador * 100',
          classificacao: [
            'Regular: <= 1',
            'Suficiente: > 1 e <= 3',
            'Bom: > 3 e <= 5',
            'Ótimo: > 5',
          ],
        },
        43: {
          numerador: 'Total de pessoas com tratamento odontológico concluído.',
          denominador:
            'Total de pessoas com primeira consulta odontológica programada.',
          resultado: 'Numerador / Denominador * 100',
          classificacao: [
            'Regular: <= 25',
            'Suficiente: > 25 e <= 50',
            'Bom: > 50 e <= 75',
            ' Ótimo: > 75 e <= 100',
          ],
        },
        39: {
          numerador: 'Total de exodontias.',
          denominador:
            'Total de procedimentos clínicos individuais preventivos, curativos e exodontias realizados.',
          resultado: 'Numerador / Denominador * 100',
          classificacao: [
            'Regular: < 8 ou >= 14',
            'Suficiente: >= 12 e < 14',
            'Bom: >= 10 e < 12',
            'Ótimo: >= 8 e < 10',
          ],
        },
        42: {
          numerador:
            'Total de pessoas participantes da ação coletiva de escovação dental supervisionada realizada em crianças com idade entre 6 e 12 anos.',
          denominador: 'Total de pessoas vinculadas à equipe.',
          resultado: 'Numerador / Denominador * 100',
          classificacao: [
            'Regular: <= 0,25',
            'Suficiente: > 0,25 e <= 0,5',
            'Bom: > 0,5 e <= 1',
            'Ótimo: > 1',
          ],
        },
        40: {
          numerador:
            'Total de procedimentos odontológicos individuais preventivos.',
          denominador:
            'Todos os procedimentos odontológicos individuais registrados.',
          resultado: 'Numerador / Denominador * 100',
          classificacao: [
            'Regular: < 40 ou > 85',
            'Suficiente: >= 40 e < 60',
            'Bom: >= 60 e < 80',
            'Ótimo: >= 80 e <= 85',
          ],
        },
        41: {
          numerador:
            'Total de procedimentos do tipo Tratamento Restaurador Atraumático.',
          denominador: 'Total de procedimentos restauradores.',
          resultado: 'Numerador / Denominador * 100',
          classificacao: [
            'Regular: <= 3',
            'Suficiente: > 3 e <= 6',
            'Bom: > 6 e <= 8',
            'Ótimo: > 8',
          ],
        },
        53: {
          numerador: 'Total de gestantes com atendimento odontológico.',
          denominador: 'Total de gestantes da equipe vinculada.',
          resultado: 'Numerador / Denominador * 100',
          classificacao: [],
        },
      }

      const indicador = nomesIndicadores[idIndicador]
      if (!indicador) return ''

      if (col == 'Numerador') {
        return indicador.numerador
      }
      if (col == 'Denominador') {
        return indicador.denominador
      }
      if (col == 'Resultado') {
        return indicador.resultado
      }
      if (col == 'Classificação') {
        return indicador.classificacao.join('<br>')
      }
    },

    getExpandedValue(item, column) {
      if (this.selectedIndicador.indicador == 54) {
        switch (column) {
          case 'CIs':
            return item.qtd_cad0_75
          case 'CIs + CDTs':
            return item.qtd_cad1_5
          case 'Cadastros':
            return item.cad_pec ?? '-'
          case 'Parâmetro':
            return item.cad_param ?? '-'
          case 'Máximo': {
            const param = Number(item.cad_param)
            return isNaN(param) ? '-' : param * 1.5
          }
        }
      } else if (this.selectedIndicador.indicador == 55) {
        switch (column) {
          case 'A':
            return item.qtd_acomp1_0
          case 'B':
            return item.qtd_acomp1_2
          case 'C':
            return item.qtd_acomp1_3
          case 'D':
            return item.qtd_acomp2_5
          case 'Cadastros':
            return item.cad_pec ?? '-'
          case 'Parâmetro':
            return item.cad_param ?? '-'
          case 'Máximo': {
            const param = Number(item.cad_param)
            return isNaN(param) ? '-' : param * 1.5
          }
        }
      } else if (this.selectedIndicador.indicador == 56) {
        switch (column) {
          case 'Cadastros':
            return item.cad_pec ?? '-'
          case 'Parâmetro':
            return item.cad_param ?? '-'
          case 'Escore cadastros':
            return item.escore_param_cad ?? '-'
          case 'Escore Acompanhamento':
            return item.escore_param_acomp ?? '-'
        }
      } else {
        switch (column) {
          case 'Indicador':
            return item.ds_indicador ?? '-'
          case 'Peso':
            return item.peso ?? '-'
          case 'Numerador':
            if (this.selectedIndicador.indicador == 47) {
              return '-'
            }
            return item.numerador ?? '-'
          case 'Denominador':
            return item.denominador ?? '-'
          case 'Pontuação':
            return item.resultado ?? '-'
          case 'Nota':
            return item.nota ?? '-'
          case 'Classificação':
            return item.classificacao ?? '-'
        }
      }
    },
  },
}
</script>

<style lang="scss">
#dashboard-por-indicador {
  margin: 30px 0;
  h2 {
    font-size: 22px;
  }
}
</style>
